import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Footer.scss";
import facebook from "../images/redes/Caralibro.svg";
import instagram from "../images/redes/Instagram.svg";
import linkedin from "../images/redes/Linkedin.svg";
import appStore from "../images/App.svg";
import logo from "../images/logoHF.png";

const Footer = () => {
  return (
    <footer id="contacto">
      <div className="containerFooter">
        {/* Columna 1 - Descripción */}
        <div className="column1">
          <a href="./index.php">
            <img src={logo} alt="Logo Asesor-Arte en Seguros México" />
          </a>
          <div className="containerTextColumn1">
            <p>
              En <strong>Asesorarte en Seguros</strong>, formamos y acompañamos a personas
              que desean emprender en el mundo financiero y de los seguros.
              Brindamos capacitación, mentoría y un sistema de crecimiento
              diseñado para ayudarte a alcanzar independencia económica mientras
              transformas vidas protegiendo el futuro de las familias mexicanas.
            </p>
          </div>
        </div>

        {/* Columna 2 - Nosotros y contacto */}
        <div className="column2">
          <div>
            <p>NOSOTROS</p>
            <div className="textColumn2">
              <a href="#inicio">
                <span>Quiénes somos</span>
              </a>
              <br />
              <a href="#porqueE">
                <span>¿Por qué unirte a nosotros?</span>
              </a>
              <br />
              <a href="https://asesorarteenseguros.com/privacidad.pdf" target="_blank" rel="noopener noreferrer">
                <span>Aviso de Privacidad</span>
              </a>
              <br />
            </div>
          </div>
          <br />
          <div>
            <p>CONTACTO</p>
            <div className="textColumn2">
              <a href="mailto:consultoria@julietazamora.com">
                <span>Envíanos un correo</span>
              </a>
              <br />
              <a href="tel:+525584514007">
                <span>55 8451 4007</span>
              </a>
            </div>
          </div>
        </div>

        {/* Columna 3 - Servicios */}
        <div className="column3">
          <div>
            <p>SERVICIOS</p>
            <div className="textColumn3">
              <a href="#servicio1">
                <span>Formación y Capacitación</span>
              </a>
              <br />
              <a href="#servicio2">
                <span>Mentorías Personalizadas</span>
              </a>
              <br />
              <a href="#servicio3">
                <span>Plan de Carrera</span>
              </a>
              <br />
              <br />
              <span className="ubicacionTitle">REGÍSTRATE</span>
              <br />
              <a href="#formulario">
                <span id="ubicacion">
                  Déjanos tus datos y únete hoy
                </span>
              </a>
              <br />
            </div>
          </div>
        </div>

        {/* Columna 4 - Apps y redes */}
        <div className="column4">
          <div>
            <p>APPS</p>
            <div>
              <span>Próximamente</span>
            </div>
            <div className="containerImgApp">
              <img src={appStore} alt="App Asesor-Arte en Seguros" />
            </div>
          </div>

          <div className="containerRedes">
            <Fade cascade="true" direction="left">
              <a href="https://www.facebook.com/profile.php?id=61580185370968&_rdc=1&_rdr#">
                <img src={facebook} alt="Facebook Asesor-Arte en Seguros" />
              </a>
               <a href="https://www.instagram.com/asesorarteenseguros?igsh=MTRnMHdjM3lxNjhldw==">
                <img src={instagram} alt="Instagram Asesor-Arte en Seguros" />
              </a>
               <a href="https://www.linkedin.com/company/asesorarte-finanzas-seguros/">
                <img src={linkedin} alt="Linkedin Asesor-Arte en Seguros" />
              </a>
            </Fade>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
